module.exports = __webpack_public_path__ + "img/line5.4dcf9875.png";